import { render, staticRenderFns } from "./valign-mid.vue?vue&type=template&id=494af5df&"
import script from "./valign-mid.vue?vue&type=script&lang=js&"
export * from "./valign-mid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports